import * as UserService from '../services/userService';
import  jwt_decode from 'jwt-decode';
import React from 'react';
import { toast } from "react-toastify";


// The API returns either a plain string or { message }; show the text, never "[object Object]".
const errorMessage = (err) => {
    const data = err && err.response ? err.response.data : null;
    if (typeof data === "string" && data) return data;
    if (data && (data.message || data.title)) return data.message || data.title;
    return "Something went wrong. Please try again.";
};

export const PROFILE_GET = "PROFILE_GET";

export const PROFILE_LOAD = "PROFILE_LOAD";

export const PROFILE_UPDATE = "PROFILE_UPDATE";


export function getProfile(data){
    return (dispatch) => {
        UserService.getProfile(data)
        .then(res => {
            dispatch({type:'PROFILE_GET',payload:res.data});
        })
        .catch(err => {
             toast.error(errorMessage(err))
        })
    }
}

export function updateProfile(data){
    return (dispatch) => {
        dispatch({type:'PROFILE_LOAD'});
        UserService.updateProfile(data)
        .then(res => {
            dispatch({type:'PROFILE_UPDATE',payload:data});
            toast.success("Profile Updated Successfully.");
        })
        .catch(err => {
             toast.error(errorMessage(err))
        })
    }
}


export function uploadImage(data){
    return (dispatch) => {
        
        UserService.uploadImage(data)
        .then(res => {
            dispatch({type:'PROFILE_IMAGE_SUCCESS',payload:res.data});
            toast.success("Profile Image Uploaded Successfully.");
        })
        .catch(err => {
             toast.error(errorMessage(err))
        })
    }
}
export function getProfileImage(){
    return (dispatch) => {
        
        UserService.getProfileImage()
        .then(res => {
            dispatch({type:'PROFILE_IMAGE_SUCCESS',payload:res.data});
        })
        .catch(err => {                        
            toast.error(errorMessage(err))
             
        })
    }
}




